import { Fragment, useState } from "react";

import AllCollections from "../../components/Client/Collections/AllCollections";

const AllCollectionsPage = () => {
  return (
    <Fragment>
      <AllCollections />
    </Fragment>
  );
};

export default AllCollectionsPage;
